/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Error/view.blocks to change it.
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Error({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Phone/Phones/Content/Phone/Related/Content/Popup/Content/Persons/Person/Relation/Error"
  
}) {
  return null
}